import { render, staticRenderFns } from "./KitsList.vue?vue&type=template&id=5a0a03ca"
import script from "./KitsList.vue?vue&type=script&lang=js"
export * from "./KitsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports